// extracted by mini-css-extract-plugin
export default {"layoutLoaderContainer":"LayoutLoader__layoutLoaderContainer--1FI","layoutLoaderText":"LayoutLoader__layoutLoaderText--1JI"};